<div class="inner-content">
    <div class="wrapper">

        <div class="wrapper-program">


            <iframe *ngIf="url" width="100%" height="100%"
                    [src]="url"
                    allowfullscreen></iframe>


            <div class="comment-wrapper" *ngIf="url && comment && comment.text">


                <div class="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.629 20.472L13.087 21.388C12.604 22.204 11.397 22.204 10.913 21.388L10.371 20.472C9.951 19.762 9.741 19.406 9.403 19.21C9.065 19.013 8.64 19.006 7.79 18.991C6.534 18.97 5.747 18.893 5.087 18.619C4.48037 18.3677 3.92917 17.9994 3.46487 17.5351C3.00057 17.0708 2.63227 16.5196 2.381 15.913C2 14.995 2 13.83 2 11.5V10.5C2 7.227 2 5.59 2.737 4.388C3.14904 3.7152 3.71445 3.14945 4.387 2.737C5.59 2 7.228 2 10.5 2H13.5C16.773 2 18.41 2 19.613 2.737C20.2854 3.14917 20.8508 3.71456 21.263 4.387C22 5.59 22 7.228 22 10.5V11.5C22 13.83 22 14.995 21.62 15.913C21.3686 16.5197 21.0002 17.071 20.5357 17.5353C20.0712 17.9996 19.5198 18.3678 18.913 18.619C18.253 18.893 17.466 18.969 16.21 18.991C15.36 19.006 14.935 19.013 14.597 19.21C14.259 19.406 14.049 19.761 13.629 20.472ZM8 11.75C7.80109 11.75 7.61032 11.829 7.46967 11.9697C7.32902 12.1103 7.25 12.3011 7.25 12.5C7.25 12.6989 7.32902 12.8897 7.46967 13.0303C7.61032 13.171 7.80109 13.25 8 13.25H13.5C13.6989 13.25 13.8897 13.171 14.0303 13.0303C14.171 12.8897 14.25 12.6989 14.25 12.5C14.25 12.3011 14.171 12.1103 14.0303 11.9697C13.8897 11.829 13.6989 11.75 13.5 11.75H8ZM7.25 9C7.25 8.80109 7.32902 8.61032 7.46967 8.46967C7.61032 8.32902 7.80109 8.25 8 8.25H16C16.1989 8.25 16.3897 8.32902 16.5303 8.46967C16.671 8.61032 16.75 8.80109 16.75 9C16.75 9.19891 16.671 9.38968 16.5303 9.53033C16.3897 9.67098 16.1989 9.75 16 9.75H8C7.80109 9.75 7.61032 9.67098 7.46967 9.53033C7.32902 9.38968 7.25 9.19891 7.25 9Z" fill="#007F88"/>
                    </svg>

                </div>

                <div class="comment">

                    <div class="text" [innerHTML]="comment.text">

                    </div>

                    <div class="teacher">
                        {{comment.comment_by}} <span> {{ comment.comment_at}}</span>
                    </div>
                </div>



            </div>



            <div *ngIf="html" [innerHTML]="this.html"></div>

        </div>


        <div class="close" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>
        </div>


    </div>
</div>
